export const getMinutesDuration = (start: string, end: string): number => {
  const [startHours, startMinutes] = start.split(':');
  const [endHours, endMinutes] = end.split(':');

  return (+endHours - +startHours) * 60 + +endMinutes - +startMinutes;
};
